import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import {
  selectRentalPropertyBudget,
  selectRentalPropertyMinimum,
  selectRentalPropertyDownPayment
} from '../../../../../store/selectors/home/equity'
import RentalPropertyDetail from './RentalPropertyDetail'
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'

export default {
  GemContainer: connect(state => {
    const downPaymentAmount = selectRentalPropertyDownPayment(state)
    const budget = selectRentalPropertyBudget(state)
    const minimum = selectRentalPropertyMinimum(state)
    const enoughEquity = budget > minimum

    return {
      qaTag: 'rentalPropertyGem',
      amount: budget < 0 ? 0 : budget,
      qualified: enoughEquity,
      downPaymentAmount
    }
  }),
  Detail: RentalPropertyDetail,
  topic: CUSTOMER_MESSAGES.INVESTMENT_PROPERTY.topic,
  topicKey: CUSTOMER_MESSAGES.INVESTMENT_PROPERTY.topicKey,
  question: CUSTOMER_MESSAGES.INVESTMENT_PROPERTY.message
}
